import { COOKIE_ECHO_USER } from 'pricing-pages-api/EarlyRequesterNames';
import { getPublicCurrencyV2Rpc, getPublicFeatureFlagsV2Rpc } from 'pricing-pages-api/__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
import { evaluatePublicRpc } from 'pricing-pages-api/__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsPublicEvaluationService';
import { handleEarlyRequestError } from 'pricing-pages-api/utils/earlyRequest';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';
import { getBooleanFromString, getQueryParam, getShortLinkForRedirect, getUtk } from 'pricing-pages-ui/earlyRequester/earlyRequesterUtils';
import { laboratoryClient } from 'pricing-pages-ui/utils/laboratoryClient';
import { getCountryCodeFromLocale } from 'pricing-pages-ui/v2/utils/countryCodeUtils';
import quickFetch from 'quick-fetch';
import { makeChirpEarlyRequest } from 'rpc-client-utils';
(function (_getCountryCodeFromLo) {
  const browserLocale = getPreferredLanguage().toLowerCase() || 'en-us';
  const isQAProxy = getIsQAProxy();
  const utk = getUtk() || '';
  window.__HUBSPOT_UTK = utk; // global var so we can access in the app code

  // const UTK_OR_UUID = getStashedUuid() || UTK || generateUuid(); // will exist & be persisted for everyone

  const countryCode = (_getCountryCodeFromLo = getCountryCodeFromLocale()) !== null && _getCountryCodeFromLo !== void 0 ? _getCountryCodeFromLo : '';
  const cookieUrl = isQAProxy ? /* eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils */
  'https://api.hubspotqa.com/cookie-echo/v1/user' : quickFetch.getApiUrl('/cookie-echo/v1/user', false);
  // Redirect detection
  quickFetch.makeEarlyRequest(COOKIE_ECHO_USER, {
    url: cookieUrl,
    type: 'GET',
    dataType: 'json',
    // Relatively quick timeout since missing the redirect is not a big deal, and we don't want to block pageload long
    // This might mean that redirects skew towards NorthAm and those with fast internet connections
    timeout: 2000,
    whenFinished(response) {
      // This endpoint will 401 if you're not logged in so wont hit this block
      const email = response.email;

      // by default we don't redirect hubspot users. We can override that by having hsRedirect=true in query param
      const hsRedirect = getQueryParam('hsRedirect');
      const shouldRedirectHubSpotUsers = getBooleanFromString(hsRedirect || '');
      if (email.indexOf('@hubspot.com') > -1 && !shouldRedirectHubSpotUsers) {
        // Don't redirect hubspot users. Important for sales
        // who want a consistent demo experience on hubspot.com
        return;
      }

      // Use redirect so we don't keep the public page in history
      const redirectUrl = getShortLinkForRedirect(window.location.href);
      window.location.replace(redirectUrl);
    }
  });
  void makeChirpEarlyRequest(Object.assign({}, evaluatePublicRpc, {
    earlyRequest: true
  }), {
    request: {
      locations: ['MERCH_CARD', 'CALCULATOR', 'HUBSPOT_CREDITS_MERCH_CARD_SMALL', 'HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE'],
      productApiNames: [],
      requestedCountryCode: countryCode
    }
  }).catch(handleEarlyRequestError);
  const preferredCountryCode = getCountryCodeFromLocale();
  void makeChirpEarlyRequest(Object.assign({}, getPublicFeatureFlagsV2Rpc, {
    earlyRequest: true
  }), {
    request: {
      utk,
      browserLocale,
      preferredCountryCode
    }
  }).catch(handleEarlyRequestError);

  // @ts-expect-error mock is only set in unit tests
  if (!quickFetch.mockRequests) {
    laboratoryClient.resolve();
  }

  // Currency endpoint - validate inputs before CHIRP call
  // Malformed values could cause the entire CHIRP call to fail
  const validatedBrowserLocale = browserLocale && typeof browserLocale === 'string' && browserLocale.length > 0 ? browserLocale : 'en';
  const validatedCountryCode = preferredCountryCode && typeof preferredCountryCode === 'string' && preferredCountryCode.length > 0 && preferredCountryCode !== 'UNDEFINED' ? preferredCountryCode : undefined;
  void makeChirpEarlyRequest(Object.assign({}, getPublicCurrencyV2Rpc, {
    earlyRequest: true
  }), {
    request: {
      browserLocale: validatedBrowserLocale,
      preferredCountryCode: validatedCountryCode
    }
  }).catch(handleEarlyRequestError);
})();